import React, { useState } from "react";
import Topnavbar from "../dashboard/topnavbar";
import Sidennav from "../dashboard/sidenavbar";
import axios from "axios"; 
import { baseurladdress } from "../baseurl";
import Swal from "sweetalert2";

function Staffupload() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const accesstoken = localStorage.getItem("token");
  const handleUpload = async () => {
    if (!file) {
      Swal.fire({
        icon: "warning",       
        title: "No file selected",
        text: "Please select an Excel file to upload.",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);
      const response = await axios.post(
        baseurladdress + `upload-staff`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accesstoken}`,
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Upload Successful",
        text: response.data.message || "Staff data uploaded successfully!",
      });
      setFile(null);
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: err.response?.data?.message || "Something went wrong!",
      });
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <Topnavbar />
      <Sidennav />

      <section style={{ marginLeft: "260px", marginTop: "80px", textAlign: "center" }}>
        <h2 style={{ fontSize: "22px", fontWeight: "600", color: "#333" }}>
          Staff Upload
        </h2>
        <p style={{ color: "#666", fontSize: "14px", marginBottom: "20px" }}>
          Upload your staff Excel file (.xlsx or .xls)
        </p>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleUpload();
          }}
        >
          <input
            type="file"
            accept=".xlsx,.xls"
            onChange={(e) => setFile(e.target.files[0])}
            style={{
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              width: "300px",
              marginBottom: "15px",
            }}
          />
          <br />
          {file && (
            <small style={{ color: "#555" }}>
              Selected file: <strong>{file.name}</strong>
            </small>
          )}
          <br />
          <button
            type="submit"
            disabled={loading}
            style={{
              marginTop: "20px",
              padding: "8px 20px",
              backgroundColor: loading ? "#7dd87d" : "#28a745", // green button
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? "Uploading..." : "Upload"}
          </button>
        </form>
      </section>
    </>
  );
}

export default Staffupload;
